<script>
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
export default {
    name: "PrDescModal",
    components: { DatePicker },
    data() {
        return {
            form: {
                id: null,
                description: "",
                datePosted: new Date(),
            },
            submitted: false,
        };
    },
    validations: {
        form: {
            description: { required },
            datePosted: { required },
        },
    },
    methods: {
        updateData(data) {
            this.submitted = false;
            this.form = JSON.parse(JSON.stringify(data));
            this.form.datePosted = new Date(data.datePosted);
        },
        async onSubmit() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            let data = JSON.parse(JSON.stringify(this.form));
            data.datePosted = this.getDate(this.form.datePosted);
            this.$emit('submit', data);
        },
    },
};
</script>
<template>
    <b-modal
        id="update-pr-description-modal"
        title="Update PR"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <form @submit.prevent="onSubmit" class="needs-validation">
            <div class="mb-3">
                <label for="description">Description </label>
                <textarea
                    id="descriptionCopy"
                    rows="3"
                    v-model="form.description"
                    placeholder="Enter Description..."
                    class="form-control"
                    :class="{
                        'is-invalid':
                            submitted && $v.form.description.$error,
                    }"
                ></textarea>
                <div
                    v-if="submitted && $v.form.description.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.description.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label for="dateCompleted">Date Posted</label>
                <date-picker 
                    v-model="form.datePosted" 
                    :first-day-of-week="1"
                    lang="en"
                    placeholder="Enter Date Posted..."
                    :class="{
                        'is-invalid':
                            submitted && $v.form.datePosted.$error,
                    }"
                ></date-picker>
                <div
                    v-if="submitted && $v.form.datePosted.$error"
                    class="invalid-feedback"
                >
                    <span v-if="!$v.form.datePosted.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    Update PR
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('update-pr-description-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>